import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';

interface SuccessErrorMessageProps {
    successMessage?: string;
    errorMessage?: string;
    onClear: () => void;
    sx?: React.CSSProperties;
}

const SuccessErrorMessage: React.FC<SuccessErrorMessageProps> = ({ successMessage, errorMessage, onClear, sx }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (successMessage || errorMessage) {
            setVisible(true);
            const timeout = setTimeout(() => {
                setVisible(false);
                onClear();
            }, 3000);
            return () => clearTimeout(timeout);
        }
    }, [successMessage, errorMessage, onClear]);

    if (!visible) return null;

    return (
        <Box>
            {successMessage && <Alert severity='success' sx={sx}>{successMessage}</Alert>}
            {errorMessage && <Alert severity='error' sx={sx}>{errorMessage}</Alert>}
        </Box>
    );
};

export default SuccessErrorMessage;
